// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelPatient } from './medicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelPatient.js';
import type { MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelPayor } from './medicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelPayor.js';
import type { MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelSubscriber } from './medicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelSubscriber.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelPlan {
    'payor'?: MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelPayor | null;
    'patient'?: MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelPatient | null;
    'subscriber'?: MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelSubscriber | null;
    'planName'?: string | null;
    'groupName'?: string | null;
    'groupNumber'?: string | null;
    'planNumber'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelPlan>> = [
        {
            "name":     "payor",
            "baseName": "payor",
            "type":     "MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelPayor"
        },
        {
            "name":     "patient",
            "baseName": "patient",
            "type":     "MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelPatient"
        },
        {
            "name":     "subscriber",
            "baseName": "subscriber",
            "type":     "MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelSubscriber"
        },
        {
            "name":     "planName",
            "baseName": "planName",
            "type":     "string"
        },
        {
            "name":     "groupName",
            "baseName": "groupName",
            "type":     "string"
        },
        {
            "name":     "groupNumber",
            "baseName": "groupNumber",
            "type":     "string"
        },
        {
            "name":     "planNumber",
            "baseName": "planNumber",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelPlan.attributeTypeMap;
    }
}
